var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block text-center shadow-md no-underline rounded-full font-semibold text-xs focus:outline-none active:shadow-none",staticStyle:{"padding-left":".9em","padding-right":"1em"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }